import axios from "axios";

export const API = axios.create({
  baseURL: process.env.REACT_APP_API_BASE_URL || "http://localhost:8000/api",
  timeout: 15000,
});

// ─── Auth: attach admin_token to every request ────────────────────────────────
API.interceptors.request.use((config) => {
  const token = localStorage.getItem("admin_token");
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// ─── Auth: if the token is invalid/expired, bounce to login ──────────────────
API.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem("admin_token");
      window.location.href = "/admin-login";
    }
    return Promise.reject(error);
  }
);

// ─── Student Meet ─────────────────────────────────────────────────────────────
export const getMeeting = () => API.get("/meeting");
export const registerStudent = (data) => API.post("/students/register", data);

// ─── Slots & Booking ─────────────────────────────────────────────────────────
export const getSlots = (date) => API.get(`/slots?date=${date}`);
export const bookSlot = (data) => API.post("/book-slot", data);

// ─── Admin ────────────────────────────────────────────────────────────────────
export const getAdminStats = () => API.get("/admin/stats");
export const getStudents = (batchId) =>
  API.get(`/students${batchId && batchId !== "all" ? `?batch_id=${batchId}` : ""}`);
export const exportStudentsCSV = (batchId) => {
  const params = batchId && batchId !== "all" ? `?batch_id=${batchId}` : "";
  return `${API.defaults.baseURL}/students/export-csv${params}`;
};
export const getBatches = () => API.get("/batches");
export const createBatch = (data) => API.post("/batches", data);
export const deleteBatch = (id) => API.delete(`/batches/${id}`);
export const assignStudentBatch = (studentId, batchId) =>
  API.patch(`/students/${studentId}/batch?batch_id=${batchId}`);
export const getAllBookings = () => API.get("/admin/bookings");
export const updateBookingStatus = (id, status) =>
  API.patch(`/admin/bookings/${id}/status?status=${status}`);
export const upsertMeeting = (data) => API.post("/admin/meeting", data);
export const sendMeetEmail = (data) => API.post("/admin/send-meet-email", data);
export const createSlots = (data) => API.post("/admin/slots", data);
export const deleteSlot = (slotId) => API.delete(`/admin/slots/${slotId}`);
export const contactFormSubmit = (data) => API.post("/contact", data);
export const getAllContacts = () => API.get("/admin/contact");

// ─── Messages (WhatsApp inbox) ────────────────────────────────────────────────
// NOTE: no leading "/api" here — API.defaults.baseURL already ends in /api
export const getConversations = () => API.get("/admin/messages/conversations");
export const getConversationThread = (phone) =>
  API.get(`/admin/messages/conversations/${phone}`);
export const sendWhatsappMessage = (data) => API.post("/admin/messages/send", data);